import React, { useEffect, useRef, useState } from "react";
import CommonForm from "../../../../../components/commonform/commonForm";
import { EmailValidate } from "../../../../../components/formValidate";
import TextEditer from "../../../../../components/inputs/texteditor";
import Snackbar from "../../../../../components/snackbar/snackbar";
import { is_email_registered } from "../../../user.api";
import moment from "moment";
let reuired = [
  "company_name",
  "person_name",
  "address",
  "email",
  "abstract_project_proposal",
  "ex_man_power",
  "capital_investment",
  "upload_proposal",
  "logo",
];
let flag = false;
export default function BasicDetails(props) {
  const currentYear = moment().year();
  const startYear = new Date().getMonth() >= 3 ? currentYear : currentYear - 1;

  const financialYears = [
    `${startYear}-${startYear + 1}`,
    `${startYear - 1}-${startYear}`,
    `${startYear - 2}-${startYear - 1}`,
  ];

  const monthIndex = moment().month(); // 0-based, Apr=3
  const fyStart = monthIndex >= 3 ? currentYear : currentYear - 1;
  const currentFY = `${fyStart}-${fyStart + 1}`;

  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const [formData, setFormData] = useState(props.formData);
  const [keyvalue, setKeyvalue] = useState(0);
  const [count, setCount] = useState(1);
  const [error, setError] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const fileInputRef = useRef(null);
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  // useEffect(() => {
  //   setFormData(props.data);
  // }, [props.data]);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const textFieldChange = (e) => {
    if (e.target.name === "email" || e.target.name === "alternate_email") {
      let erroremail = !EmailValidate(e.target.value);

      setError({ ...error, [e.target.name]: erroremail });
    }
    // if (e.target.name === "product_desc" && e.taget.value === '<p><br></p>' ) {
    //   console.log("hi")
    //   setSnackMessage("Please fill all reuired fields");
    //   setIsSnackError(false);
    //   setSnackOpen(true);

    // }
    let name = e.target.name;

    let value = e.target.value;

    // Restrict special characters for specific text fields
    const noSpecialCharFields = [
      "company_name",
      "person_name",
      "person_designation",
      "address",
    ];

    if (noSpecialCharFields.includes(name)) {
      // Allow only letters, numbers and spaces
      value = value.replace(/[^a-zA-Z0-9 ]/g, "");
    }
    let data = formData;
    data[name] = value;
    setFormData(data);
    setKeyvalue(keyvalue + 1);
  };
  const handleNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9]/g, "");
    data = { ...data, [name]: newValue };
    setFormData(data);
  };

  const addNewProductProfile = (i) => {
    let data = { ...formData };

    data.product_profiles.push({ product_name: "", product_desc: "" });
    setFormData(data);
    setCount(count + 1);
  };
  const RemoveProduct = (i) => {
    let data = { ...formData };
    data.product_profiles.splice(i, 1);
    setCount(data);
    setCount(count + 1);
  };
  const handleMultiChange = (e, i) => {
    let data = { ...formData };

    let value = e.target.value;

    // Restrict special characters for product name and description
    if (e.target.name === "product_name" || e.target.name === "product_desc") {
      value = value.replace(/[^a-zA-Z0-9 ]/g, "");
    }

    data.product_profiles[i] = {
      ...data.product_profiles[i],
      [e.target.name]: value,
    };

    setFormData(data);
  };
  const handleNextSubmit = (e) => {
    e.preventDefault();
    let emailData = { email: formData.email };
    if (
      emailRegex.test(formData?.email) === true &&
      (emailRegex.test(formData?.alternate_email) === true ||
        !formData?.alternate_email ||
        formData?.alternate_email === "")
    ) {
      if (!props.update)
        is_email_registered(emailData)
          .then((res) => {
            if (
              formData.upload_proposal !== null &&
              formData.upload_proposal !== undefined &&
              formData.upload_proposal !== ""
            ) {
              let productFlag = false;
              productFlag = formData?.product_profiles?.some(
                (pr) => pr?.product_desc === ""
              );
              if (!productFlag) {
                props.action(0, formData);
              } else {
                setSnackOpen(true);
                setSnackMessage("Please fill the product description");
                setIsSnackError(true);
              }
            } else {
              setSnackOpen(true);
              setSnackMessage("Please choose a valid file");
              setIsSnackError(true);
            }
          })
          .catch((error) => {
            setSnackMessage(error.response.data.message);
            setIsSnackError(true);
            setSnackOpen(true);
            // setIsActive(false);
          });
      else {
        if (
          formData.upload_proposal !== null &&
          formData.upload_proposal !== undefined &&
          formData.upload_proposal !== ""
        ) {
          props.action(0, formData);
        } else {
          setSnackOpen(true);
          setSnackMessage("Please choose a valid file");
          setIsSnackError(true);
        }
      }
    } else {
      setSnackOpen(true);
      setSnackMessage("Please enter a valid email");
      setIsSnackError(true);
    }
    // const errors = FormValidate(formData, reuired);
    // if (Object.keys(errors).length === 0) {

    // } else {
    //   setSnackMessage("Please fill all reuired fields");
    //   setIsSnackError(false);
    //   setSnackOpen(true);
    // }
  };

  const handleCheckChange = (e, item) => {
    flag = false;
    let data = [...props.domainData];

    data[item]["checked"] = e.target.checked;
    //setFormData({ ...formData, any_other_flag: false });
    if (props.domainData) {
      props.domainData.forEach((item) => {
        if (item.checked) flag = true;
      });
    }
    props.setDomain(data);
  };
  const handleValid = () => {
    let flags = false;
    if (props.domainData) {
      props.domainData.forEach((item) => {
        if (item.checked) flags = true;
      });
    }
    return flags;
  };
  const handleOtherChange = (e) => {
    // let data = [...props.domainData];
    // data.forEach((item) => {
    //   item["checked"] = false;
    // });
    //
    // props.setDomain(data);
    setFormData({ ...formData, [e.target.name]: e.target.checked });
    console.log(e.target.value);
  };
  const handleFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    if (
      type?.toLowerCase() === "doc" ||
      type?.toLowerCase() === "docx" ||
      type?.toLowerCase() === "pdf"
    ) {
      let mb = size / Math.pow(1024, 2);

      if (mb < 5) {
        setFormData({
          ...formData,
          file_name: e.target.files[0].name,
          [e.target.name]: e.target.files[0],
        });
        if (props.update) {
          props.handlefile();
        }
      } else {
        setSnackMessage("File size is greater than 5MB");
        setIsSnackError(true);
        setSnackOpen(true);
        setFormData({
          ...formData,
          file_name: null,
          [e.target.name]: null,
        });
      }
    } else {
      setSnackMessage("File should be in .doc / .docx / .pdf format");
      setIsSnackError(true);
      setSnackOpen(true);
      setFormData({
        ...formData,
        file_name: null,
        [e.target.name]: null,
      });
    }
  };
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const size = file.size;
    const type = file.name.split(".").pop().toLowerCase();
    const maxMB = 1;
    const fileSizeMB = size / (1024 * 1024);

    const isValidType = ["jpg", "jpeg", "png"].includes(type);

    if (!isValidType) {
      showError("File should be in .png / .jpeg / .jpg format");
      resetFileInput();
      return;
    }

    if (fileSizeMB > maxMB) {
      showError("File size is greater than 1MB");
      resetFileInput();
      return;
    }

    // valid
    setFormData({
      ...formData,
      logo_name: e.target.files[0].name,
      logo: e.target.files[0],
    });
  };

  const showSnackbar = (message) => {
    setSnackMessage(message);
    setIsSnackError(true);
    setSnackOpen(true);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    // if (!flag) {
    //   handleEventList();
    // }
  };
  useEffect(() => {
    setFormData((prev) => ({
      ...props.formData,
      company_status: prev?.company_status ?? "new_company",
      financial_year: prev?.financial_year ?? currentFY,
    }));
    // Initialize financial_records from incoming data or seed with one for existing company
    setFormData((prev) => {
      const incoming = props.formData?.financial_records;
      if (Array.isArray(incoming) && incoming.length > 0) {
        return { ...prev, financial_records: incoming.slice(0, 3) };
      }
      if ((prev?.company_status || props.formData?.company_status) === "existing_company") {
        return {
          ...prev,
          financial_records: [
            { financial_year: prev?.financial_year || currentFY, fy_turnover: prev?.fy_turnover || "" },
          ],
        };
      }
      return { ...prev, financial_records: prev?.financial_records || [] };
    });
    if (!formData.product_profiles) {
      setFormData((prev) => ({
        ...prev,
        product_profiles: [{ product_name: "", product_desc: "" }],
      }));
    }
  }, [props.formData]);

  const handleProductDesc = (val, i) => {
    let data = { ...formData };
    data.product_profiles[i] = {
      ...data.product_profiles[i],

      product_desc: val === "<p><br></p>" ? "" : val,
    };

    setFormData(data);
    setCount(count + 1);
  };
  const handleFieldNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, ""); // Remove non-numeric characters except for the decimal point
    newValue = newValue.match(/^\d{0,5}(?:\.\d{0,2})?$/); // Apply the regex pattern to ensure the format
    if (newValue) {
      data = { ...data, [name]: newValue[0] }; // If the newValue matches the pattern, update the data object
    }
    setFormData(data);
  };

  const handleEmploymentNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, ""); // Remove non-numeric characters except for the decimal point
    newValue = newValue.match(/^\d{0,4}(?:\.\d{0,2})?$/); // Apply the regex pattern to ensure the format
    if (newValue) {
      data = { ...data, [name]: newValue[0] }; // If the newValue matches the pattern, update the data object
    }
    setFormData(data);
  };
  const handleFYTurnoverChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, ""); // Remove non-numeric characters except for the decimal point
    newValue = newValue.match(/^\d{0,10}(?:\.\d{0,2})?$/); // Apply the regex pattern to ensure the format
    if (newValue) {
      data = { ...data, [name]: newValue[0] }; // If the newValue matches the pattern, update the data object
    }
    setFormData(data);
  };
  // Financial records helpers
  const addFinancialRecord = () => {
    setFormData((prev) => {
      const list = Array.isArray(prev.financial_records) ? prev.financial_records : [];
      if (list.length >= 3) return prev;
      return {
        ...prev,
        financial_records: [...list, { financial_year: "", fy_turnover: "" }],
      };
    });
  };
  const removeFinancialRecord = (idx) => {
    setFormData((prev) => {
      const list = Array.isArray(prev.financial_records) ? [...prev.financial_records] : [];
      list.splice(idx, 1);
      return { ...prev, financial_records: list };
    });
  };
  const handleFinancialRecordChange = (idx, field, value) => {
    setFormData((prev) => {
      const list = Array.isArray(prev.financial_records) ? [...prev.financial_records] : [];
      list[idx] = { ...list[idx], [field]: field === "fy_turnover" ? value.replace(/[^0-9.]/g, "").slice(0, 13) : value };
      return { ...prev, financial_records: list };
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the selected financial year
    }));
  };
  const showError = (message) => {
    setSnackMessage(message);
    setIsSnackError(true);
    setSnackOpen(true);
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setFormData((prev) => ({
      ...prev,
      logo: null,
      logo_name: null,
    }));
    setFileInputKey(Date.now());
  };

  const handleCompanyTypeChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      company_status: value,
      // Reset financial year and turnover if New Company is selected
      ...(value === "new_company"
        ? { financial_year: "", fy_turnover: "", financial_records: [] }
        : { financial_year: currentFY, financial_records: prev.financial_records?.length ? prev.financial_records : [{ financial_year: currentFY, fy_turnover: "" }] }),
    }));
  };

  const handleAbstractChange = (e) => {
    const value = e.target.value.slice(0, 200);
    setFormData((prev) => ({
      ...prev,
      abstract_project_proposal: value,
    }));
  };

  return (
    <div className="">
      <form onSubmit={handleNextSubmit}>
        <div className="">
          <CommonForm
            fieldType="text"
            label="Company Name"
            required
            name="company_name"
            disabled={props.edit}
            value={formData.company_name ?? ""}
            onChange={(e) => {
              textFieldChange(e);
            }}
            {...props}
          />

          <CommonForm
            fieldType="text"
            label="Contact Person Name"
            required
            name="person_name"
            value={formData.person_name ?? ""}
            onChange={(e) => {
              textFieldChange(e);
            }}
            {...props}
          />
          <CommonForm
            fieldType="text"
            label="Contact Person Designation"
            required
            name="person_designation"
            value={formData.person_designation ?? ""}
            onChange={(e) => {
              textFieldChange(e);
            }}
            {...props}
          />
          <CommonForm
            fieldType="email"
            label="Primary Mail Id"
            error={error.email}
            required
            disabled={props.edit}
            name="email"
            value={formData.email ?? ""}
            onChange={(e) => {
              textFieldChange(e);
            }}
            {...props}
          />
          {!props.update && (
            <CommonForm
              fieldType="text"
              label="Primary Contact No"
              error={error.mobile_number}
              required
              disabled={true}
              name="mobile_number"
              value={formData.mobile_number ?? ""}
              {...props}
            />
          )}
          <CommonForm
            fieldType="text"
            label="Website Link"
            name="site_link"
            value={formData.site_link ?? ""}
            onChange={(e) => {
              textFieldChange(e);
            }}
            {...props}
          />
          <CommonForm
            key={fileInputKey}
            ref={fileInputRef}
            fieldType="file"
            // required={!formData.logo_name ? true : false}
            name="logo"
            {...props}
            id="logo"
            fileName={formData.logo_name}
            label="Upload Company Logo"
            accept=".jpg,.jpeg,.png"
            type="file"
            variant="outlined"
            onChange={handleLogoChange}
            className={"mb-2"}
          />
          <CommonForm
            fieldType="multiline"
            label="Address"
            required
            name="address"
            value={formData.address ?? ""}
            onChange={(e) => {
              textFieldChange(e);
            }}
            {...props}
          />
          <CommonForm
            fieldType="email"
            label="Alternate Mail Id"
            error={error.alternate_email}
            name="alternate_email"
            value={
              formData.alternate_email && formData.alternate_email !== "null"
                ? formData.alternate_email
                : ""
            }
            onChange={(e) => {
              textFieldChange(e);
            }}
            {...props}
          />
          <label className="control-label mylabel mt-3">
            Alternate Contact No
          </label>
          <div className="d-flex col-12 align-items-end ">
            <div className="col-1 ">
              <CommonForm
                fieldType="text"
                error={error.country_code}
                name="country_code"
                maxLength="4"
                value={formData.country_code ?? ""}
                onChange={(e) => {
                  handleNumberChange(e);
                }}
                {...props}
              />
            </div>
            <div className="p-1"></div>
            <div className="col-11">
              <CommonForm
                fieldType="text"
                error={error.alternate_phone}
                name="alternate_phone"
                maxLength="10"
                value={formData.alternate_phone ?? ""}
                onChange={(e) => {
                  handleNumberChange(e);
                }}
                {...props}
              />
            </div>
          </div>

          {/* --- Company Type Radio --- */}
          <div className="mt-2 mb-1">
            <label className="control-label mylabel">
              Are you a New Company / Existing Company?
            </label>
            <div>
              <label>
                <input
                  type="radio"
                  name="company_status"
                  value="new_company"
                  checked={formData.company_status === "new_company"}
                  onChange={handleCompanyTypeChange}
                />{" "}
                New Company
              </label>
              <label className="ms-3">
                <input
                  type="radio"
                  name="company_status"
                  value="existing_company"
                  checked={formData.company_status === "existing_company"}
                  onChange={handleCompanyTypeChange}
                />{" "}
                Existing Company
              </label>
            </div>
          </div>

          {/* --- Financial Records (conditional, max 3) --- */}
          {formData.company_status === "existing_company" && (
            <>
              <div className="header-label mt-3">Previous Financial Records</div>
              {(formData.financial_records || []).map((rec, idx) => {
                // Build year options excluding years selected in other records
                const selectedYears = (formData.financial_records || []).map((r, i) => (i === idx ? null : r.financial_year)).filter(Boolean);
                const availableYears = financialYears.filter((y) => !selectedYears.includes(y));
                return (
                  <div className="section-datas-cont" key={`fr-${idx}`}>
                    <div className="row">
                      <div className="col-6">
                        <label className="control-label mylabel mb-2">Financial Year</label>
                        <select
                          className="form-select mandatory-select mb-2"
                          aria-label="Select Financial Year"
                          required
                          value={rec.financial_year || ""}
                          onChange={(e) => handleFinancialRecordChange(idx, "financial_year", e.target.value)}
                        >
                          <option value="">Select Financial Year</option>
                          {availableYears.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-6">
                        <CommonForm
                          fieldType="text"
                          label="Turnover (in Lakhs)"
                          value={rec.fy_turnover || ""}
                          onChange={(e) => handleFinancialRecordChange(idx, "fy_turnover", e.target.value)}
                          {...props}
                          required
                        />
                      </div>
                    </div>
                    <div className="more-btn-cnt">
                      {((formData.financial_records || []).length > 1) && (
                        <button type="button" className="btn btn-primary mt-2" onClick={() => removeFinancialRecord(idx)}>
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
              {((formData.financial_records || []).length < 3) && (
                <button type="button" className="btn btn-primary" onClick={addFinancialRecord}>
                  Add Previous
                </button>
              )}
            </>
          )}
        </div>

        {/* --- Project Details Section --- */}
        <div className="mt-3">
          <div className="header-label">Project Details</div>
          <hr></hr>
          <CommonForm
            fieldType="multiline"
            label="Abstract Project Proposal"
            required
            name="abstract_project_proposal"
            value={formData.abstract_project_proposal ?? ""}
            onChange={handleAbstractChange}
            {...props}
            className="mt-2"
            inputProps={{ maxLength: 200 }}
            helperText={`${
              formData.abstract_project_proposal?.length || 0
            }/200`}
          />
          <CommonForm
            fieldType="file"
            required={!formData.file_name ? true : false}
            name="upload_proposal"
            {...props}
            id="upload_proposal"
            fileName={formData.file_name}
            label="Upload Project Proposal"
            accept=".pdf,.docx,.doc"
            type="file"
            variant="outlined"
            onChange={handleFileChange}
          />
          <div className="file-up-helper mx-lg-1">
            *Upload only .pdf , .docx , .doc and Size should be less than 5MB
          </div>
          {typeof formData.upload_proposal === "string" &&
            formData.upload_proposal !== "" && (
              <button
                type="button"
                className="primary-btn m-0"
                onClick={() => {
                  window.open(`${result}${formData.upload_proposal}`, "_blank");
                }}
              >
                View File
              </button>
            )}
          {/* Product Profile */}
          {formData.product_profiles?.map((e, i) => (
            <div className="section-datas-cont" key={i + "thprofile"}>
              <div className="header-label">Product Profile</div>
              <div className="section-Cont  pb-1">
                <div className="fieldset">
                  <CommonForm
                    fieldType="text"
                    label="Product Name"
                    required
                    name="product_name"
                    value={e?.product_name}
                    onChange={(ev) => handleMultiChange(ev, i)}
                    {...props}
                  />
                </div>
                <div key={i}>
                  <CommonForm
                    fieldType="multiline"
                    label="Product Description"
                    required
                    name="product_desc"
                    value={e?.product_desc}
                    onChange={(ev) => handleMultiChange(ev, i)}
                    {...props}
                  />
                </div>
              </div>
              <div className="more-btn-cnt">
                {formData.product_profiles.length === i + 1 && (
                  <button
                    style={{ marginLeft: 5 }}
                    type="button"
                    {...props}
                    className="btn btn-primary"
                    onClick={() => addNewProductProfile(i)}
                  >
                    Add More Product
                  </button>
                )}
                {formData.product_profiles.length > 1 && (
                  <button
                    {...props}
                    type="button"
                    className="btn btn-primary mt-3"
                    onClick={() => RemoveProduct(i)}
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>
          ))}
          <CommonForm
            fieldType="text"
            label="Capital Investment (in Lakhs)"
            required
            name="capital_investment"
            value={formData.capital_investment ?? ""}
            onChange={handleFieldNumberChange}
            {...props}
          />
          <CommonForm
            fieldType="text"
            label="Initial Direct Employment"
            required
            name="ex_man_power"
            value={formData.ex_man_power ?? ""}
            onChange={handleEmploymentNumberChange}
            {...props}
          />
          {/* --- Company Domain --- */}
          <div>
            <div className="header-label">Company Domain</div>
            <div className="check-box-cont mb-2">
              {props.domainData &&
                props.domainData.map((item, index) => (
                  <CommonForm
                    fieldType="checkbox"
                    value={item.checked}
                    required={!formData.any_other_flag && !handleValid()}
                    checked={item.checked}
                    onChange={(e) => handleCheckChange(e, index)}
                    label={item.domain_name}
                    {...props}
                  />
                ))}
              <CommonForm
                fieldType="checkbox"
                onChange={handleOtherChange}
                label="Any Other"
                name="any_other_flag"
                checked={formData.any_other_flag}
                value={formData.any_other_flag}
                {...props}
              />
            </div>
            {formData.any_other_flag && formData.any_other_flag !== "0" && (
              <div>
                <CommonForm
                  fieldType="text"
                  placeholder="Please specify the Domain.."
                  required
                  name="any_other_domain"
                  value={formData.any_other_domain ?? ""}
                  onChange={textFieldChange}
                  {...props}
                />
              </div>
            )}
          </div>
        </div>
        {/* ///actions ////////////// */}
        <center>
          <div className="footer-buttons-newreg pix m-2">
            <button type="submit" className="primary-btn basic-submit">
              SUBMIT TO NEXT STEP
            </button>
          </div>
        </center>
      </form>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
